/* eslint-disable no-nested-ternary */
import OptionHOC from '@platform/react/hoc/autocomplete/option'
import { Grid } from '@mui/material'
import AvatarImage from 'ui/Element/Image/Avatar'
import { forwardRef } from 'react'
import Chip from 'ui/Element/Text/Chip'
import Text from 'ui/Element/Text'
import { getDocumentationIcon } from 'lib/util/icon'

const styles = theme => ({
  option: {
    gap: 12,
  },
  subLabel: {
    gap: 4,
    flexWrap: 'nowrap',
    display: 'flex!important',
  },
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    ...theme.typography['14/medium'],
    '& strong': {
      backgroundColor: theme.palette.success[50],
    },
  },
})

/**
 * Displays a Docchunk for the {@link Autocomplete} component. Will display a {@link Chip}
 * at the bottom with all the products where the doc chunk was found.
 *
 * @param {Object} classes  styling for the option
 * @param {Object} props    props for the option
 *
 * @returns {*}
 */
const DocumentationOption = (classes, props = {}) => {
  const { option } = props || {}

  const icon = getDocumentationIcon({
    name: option.value?.documentationType,
    nodeType: 'documentation',
  })

  const {
    value: {
      image = null,
      product,
      label,
    } = {},
  } = option || {}

  const ForwardedChip = forwardRef((chipProps, ref) => <Chip forwardedRef={ref} {...chipProps} />)
  const productLabels = product.map((item, index) => (
    <ForwardedChip
      key={index}
      value={item}
      size={'tiny'}
      color={'pending.700'}
      backgroundColor={'pending.50'}
    />
  ))

  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image.id, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Grid
      container
      direction={'row'}
      flexWrap={'nowrap'}
      className={classes.option}
    >
      <Grid
        item
        xs={'auto'}
        className={classes.icon}
      >
        <AvatarImage
          attachment={attachment}
          shape={'circular'}
          icon={{
            source: icon || {},
            name: 'document',
            color: 'text.regular',
            background: 'gray.960',
          }}
        />
      </Grid>
      <Grid
        item
        container
        xs={'auto'}
        sx={{ flexShrink: '1!important' }}
      >
        <Grid
          container
          height={'100%'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={2}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          {productLabels?.length ? (
            <Text
              maxLines={1}
              component={'div'}
              value={productLabels}
              className={classes.subLabel}
            />
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(DocumentationOption, styles)
